module.exports = __webpack_public_path__ + "static/BannerSoftwareFactory-053a314581c5a8e8e83b5a8a49adbd2c.png";